import { startMouseMove } from '../../../../../utils';
import { getDeltaValue } from '../../utils/func';
import FloatPortal from "../../../../Portal/FloatPortal";
import throttle from "lodash-es/throttle";
import pickBy from "lodash-es/pickBy";
import isEqual from "lodash-es/isEqual";
import uiData, { MARGIN_FIELD_SET, PADDING_FIELD_SET } from './uiData';
const __script_base__ = {
  props: ['showPanelName', '_style'],
  data() {
    return {
      uiData,
      style: {},
      helpText: `
      1.按住SHIFT拖动锚点以打开上下/左右边距同步开关 <br>
      2.双击高亮区域以编辑具体边距值 <br>
      3.双击蓝色内容区域以编辑具体高宽值 <br>
      4.输入完成后可按下ESC完成输入 <br>
      5.双击锚点可重置回默认值
`,
      modifyField: null,
      paddingStandObj: {},
      marginStandObj: {},
      highlight: null,
      mouseLeft: false,
      borderStyle: {},
      borderRadiusStyle: {},
      boxShadowStyle: {}
    };
  },
  components: {
    FloatPortal
  },
  methods: {
    throttleCommit: throttle(function (field, value) {
      this.style = {
        ...this.style,
        [field]: value
      };
      const asyncLockFiledPair = [['marginLeft', 'marginRight'], ['marginTop', 'marginBottom'], ['paddingLeft', 'paddingRight'], ['paddingTop', 'paddingBottom']];
      asyncLockFiledPair.forEach(pair => {
        if (this.ifShiftKeyDown) {
          const index = pair.findIndex(item => item === field);
          if (index > -1) {
            const oppositeIndex = Number(!index);
            this.style[pair[oppositeIndex]] = value;
          }
        }
      });
      this.style = pickBy({
        ...this.style
      }, v => v !== '' && v !== undefined);
    }, 200),
    handleKeyDown(event) {
      const key = event.which;
      switch (key) {
        // 按下了shift键
        case 16:
          this.ifShiftKeyDown = true;
          break;
        // blur所有input
        case 27:
          document.getElementById('blurInputAnchor').focus();
          break;
        default:
      }
    },
    handleKeyUp(event) {
      const key = event.which;
      // 松开了shift键
      if (key === 16) {
        this.ifShiftKeyDown = false;
      }
    },
    mouseLeave() {
      this.mouseLeft = true;
    },
    handleContentDbClick(e) {
      const spanText = e.target;
      if (spanText) {
        spanText.classList.add('hide');
        const input = spanText.nextElementSibling;
        input.classList.add('actived');
        input.focus();
        input.onblur = function () {
          spanText.classList.remove('hide');
          input.classList.remove('actived');
          input.onblur = null;
        };
      }
    },
    handleDbClick(e) {
      const indicator = e.target;
      indicator.classList.add('actived');
      const input = indicator.nextElementSibling;
      input.focus();
      input.onblur = function () {
        indicator.classList.remove('actived');
        indicator.onblur = null;
      };
    },
    handleAnchorMove(e, field) {
      const that = this;
      switch (true) {
        case field === 'paddingLeft' || field === 'marginLeft':
          document.body.style.cursor = 'w-resize';
          break;
        case field === 'paddingRight' || field === 'marginRight':
          document.body.style.cursor = 'e-resize';
          break;
        case field === 'paddingTop' || field === 'marginTop':
          document.body.style.cursor = 'n-resize';
          break;
        case field === 'paddingBottom' || field === 'marginBottom':
          document.body.style.cursor = 's-resize';
          break;
        default:
      }
      this.modifyField = field;
      const originValue = that.style[field] || 0;
      let originNumber = originValue.toString().indexOf('px') === -1 ? originValue : originValue.slice(0, -2);
      originNumber = parseInt(originNumber, 10);
      this.$el.focus();
      startMouseMove({
        initialEvent: e,
        onMove: ({
          deltaX,
          deltaY
        }) => {
          let standStyle;
          let standMoveDirection;
          if (MARGIN_FIELD_SET.includes(field)) {
            standStyle = that.marginStandObj;
            standMoveDirection = field.split('margin')[1].toLowerCase();
          } else if (PADDING_FIELD_SET.includes(field)) {
            standStyle = that.paddingStandObj;
            standMoveDirection = field.split('padding')[1].toLowerCase();
          }
          const deltaValue = getDeltaValue(deltaX, deltaY, field);
          standStyle[standMoveDirection] = `${-deltaValue}px`;
          standStyle[`border-${standMoveDirection}`] = '1px solid red';
          standStyle.zIndex = 999;
          this.deltaValue = deltaValue;
          let finalNumber;
          // 因为体验问题，采取取反，magic！
          if (['marginLeft', 'marginRight', 'marginTop'].includes(field)) {
            finalNumber = originNumber - deltaValue;
          } else {
            finalNumber = originNumber + deltaValue;
          }
          // 内边距最终结果不会为负数
          if (PADDING_FIELD_SET.includes(field)) {
            finalNumber = finalNumber < 0 ? 0 : finalNumber;
          }
          that.throttleCommit.call(that, field, finalNumber);
        },
        onEnd: () => {
          this.modifyField = null;
          document.body.style.cursor = 'default';
          this.deltaValue = 0;
          this.paddingStandObj = {};
          this.marginStandObj = {};
        }
      });
    },
    handleMouseLeave(field) {
      if (this.modifyField) return;
      if (field === 'margin') {
        this.highlight = null;
      } else if (field === 'padding') {
        this.highlight = 'margin';
      } else if (field === 'content') {
        this.highlight = 'padding';
      }
    },
    handleMouseEnter(field) {
      if (this.modifyField) return;
      this.highlight = field;
    }
  },
  watch: {
    style: {
      deep: true,
      handler() {
        if (!isEqual(this.style, this._style)) {
          this.$emit('commitstyle', this.style);
        }
      }
    },
    _style: {
      deep: true,
      immediate: true,
      handler() {
        if (!isEqual(this.style, this._style)) {
          this.style = {
            ...this._style
          };
          // 复制所有borderStyle&&borderColor
          this.borderStyle = pickBy(this.style, (field, key) => /border\w*Style/.test(key) || /border\w*Color/.test(key));
          this.borderRadiusStyle = pickBy(this.style, (f, key) => key === 'borderRadius');
          this.boxShadowStyle = pickBy(this.style, (f, key) => key === 'boxShadow');
        }
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('keyup', this.handleKeyUp);
    document.addEventListener('mouseleave', this.mouseLeave);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('keyup', this.handleKeyUp);
    document.removeEventListener('mouseleave', this.mouseLeave);
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "uc-style-thumnail-wrapper",
    attrs: {
      tabindex: "0"
    }
  }, [_c("div", {
    staticStyle: {
      float: "right",
      position: "relative"
    }
  }, [_c("i", {
    staticClass: "fa fa-info-circle uc-inputbox-reset-button",
    staticStyle: {
      position: "relative",
      "z-index": "1000"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c("FloatPortal", {
    staticClass: "uc-inputbox-reset-tip"
  }, [_c("div", {
    staticClass: "uc-inputbox-reset-tip-portal",
    domProps: {
      innerHTML: _vm._s(_vm.helpText)
    }
  })])], 1), _vm._v(" "), _c("div", {
    staticClass: "uc-style-thumnail uc-style-thumnail-margin",
    class: {
      "uc-style-thumnail-highlight": _vm.highlight === "margin"
    },
    style: Object.assign({}, _vm.boxShadowStyle, {
      zIndex: 990
    }),
    on: {
      mouseenter: function () {
        _vm.handleMouseEnter("margin");
      },
      mouseleave: function () {
        _vm.handleMouseLeave("margin");
      }
    }
  }, [_c("div", _vm._l(_vm.uiData.fieldSet.margin, function (group, index) {
    return _c("div", {
      key: index,
      staticClass: "uc-style-thumnail-value-indicator-group"
    }, [_c("span", {
      class: "uc-style-thumnail-anchor-tip-" + group.direction + " uc-style-thumnail-value-indicator",
      attrs: {
        title: group.title
      },
      on: {
        dblclick: _vm.handleDbClick
      }
    }, [_vm._v("\n          " + _vm._s(_vm.style[group.fieldName] || "-") + "\n        ")]), _vm._v(" "), _c("input", {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: _vm.style[group.fieldName],
        expression: "style[group.fieldName]",
        modifiers: {
          number: true
        }
      }],
      class: "uc-mini-inputbox uc-style-thumnail-anchor-tip-" + group.direction,
      domProps: {
        value: _vm.style[group.fieldName]
      },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return;
          }
          _vm.$set(_vm.style, group.fieldName, _vm._n($event.target.value));
        },
        blur: function ($event) {
          return _vm.$forceUpdate();
        }
      }
    }), _vm._v(" "), _c("svg", {
      class: "uc-style-thumnail-esm-modal-svg " + (_vm.modifyField === group.fieldName ? "hilight" : ""),
      style: group.svgStyle.basic,
      attrs: {
        width: group.svgStyle.width,
        height: group.svgStyle.height,
        viewBox: group.svgStyle.viewBox,
        preserveAspectRatio: "none",
        "data-link-anchor": group.fieldName
      }
    }, [_c("polygon", {
      staticStyle: {
        fill: "#ff1f1f3d",
        "pointer-events": "visible"
      },
      attrs: {
        points: group.polygonPoints
      }
    })])]);
  }), 0), _vm._v(" "), _c("FloatPortal", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.modifyField,
      expression: "modifyField"
    }],
    staticStyle: {
      height: "100%",
      width: "100%",
      position: "absolute"
    },
    attrs: {
      "portal-style": "pointer-events:none"
    }
  }, [_vm.showPanelName === "style" ? _c("div", {
    staticClass: "uc-style-thumnail-stand",
    class: {
      "uc-style-thumnail-topLayer": _vm.modifyField && _vm.modifyField.indexOf("margin") !== -1
    },
    style: _vm.marginStandObj
  }, [_c("div", {
    staticClass: "uc-style-thumnail-anchor-tip-wrapper"
  }, _vm._l(_vm.uiData.fieldSet.margin.filter(function (item) {
    return _vm.modifyField === item.fieldName;
  }), function (group, index) {
    return _c("span", {
      key: index,
      class: "uc-style-thumnail-anchor-tip-" + group.direction
    }, [_vm._v("\n            " + _vm._s(_vm.modifyField !== "marginBottom" ? _vm.deltaValue > 0 ? "-" + _vm.deltaValue : "+" + -_vm.deltaValue : _vm.deltaValue > 0 ? "+" + _vm.deltaValue : "" + _vm.deltaValue) + "\n          ")]);
  }), 0)]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "uc-style-thumnail-anchor-wrapper"
  }, _vm._l(_vm.uiData.fieldSet.margin, function (group, index) {
    return _c("div", {
      key: index,
      class: "uc-style-thumnail-anchor uc-style-thumnail-anchor-" + group.direction,
      on: {
        mousedown: function (e) {
          _vm.handleAnchorMove(e, group.fieldName);
        },
        touchstart: function (e) {
          _vm.handleAnchorMove(e, group.fieldName);
        }
      }
    });
  }), 0), _vm._v(" "), _c("span", {
    staticClass: "uc-style-thumnail-title"
  }, [_vm._v("\n      外边距\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "uc-style-thumnail uc-style-thumnail-border",
    style: _vm.borderStyle
  }, [_c("div", {
    staticClass: "uc-style-thumnail uc-style-thumnail-padding",
    class: {
      "uc-style-thumnail-highlight": _vm.highlight === "padding"
    },
    staticStyle: {
      "z-index": "991"
    },
    on: {
      mouseenter: function () {
        _vm.handleMouseEnter("padding");
      },
      mouseleave: function () {
        _vm.handleMouseLeave("padding");
      }
    }
  }, [_c("div", _vm._l(_vm.uiData.fieldSet.padding, function (group, index) {
    return _c("div", {
      key: index,
      staticClass: "uc-style-thumnail-value-indicator-group"
    }, [_c("span", {
      class: "uc-style-thumnail-anchor-tip-" + group.direction + " uc-style-thumnail-value-indicator",
      attrs: {
        title: group.title
      },
      on: {
        dblclick: _vm.handleDbClick
      }
    }, [_vm._v("\n              " + _vm._s(_vm.style[group.fieldName] || "-") + "\n            ")]), _vm._v(" "), _c("input", {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: _vm.style[group.fieldName],
        expression: "style[group.fieldName]",
        modifiers: {
          number: true
        }
      }],
      class: "uc-mini-inputbox uc-style-thumnail-anchor-tip-" + group.direction,
      domProps: {
        value: _vm.style[group.fieldName]
      },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return;
          }
          _vm.$set(_vm.style, group.fieldName, _vm._n($event.target.value));
        },
        blur: function ($event) {
          return _vm.$forceUpdate();
        }
      }
    }), _vm._v(" "), _c("svg", {
      class: "uc-style-thumnail-esm-modal-svg " + (_vm.modifyField === group.fieldName ? "hilight" : ""),
      style: group.svgStyle.basic,
      attrs: {
        width: group.svgStyle.width,
        height: group.svgStyle.height,
        viewBox: group.svgStyle.viewBox,
        preserveAspectRatio: "none",
        "data-link-anchor": group.fieldName
      }
    }, [_c("polygon", {
      staticStyle: {
        fill: "#ff1f1f3d",
        "pointer-events": "visible"
      },
      attrs: {
        points: group.polygonPoints
      }
    })])]);
  }), 0), _vm._v(" "), _c("FloatPortal", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.modifyField,
      expression: "modifyField"
    }],
    staticStyle: {
      height: "100%",
      width: "100%",
      position: "absolute"
    },
    attrs: {
      "portal-style": "pointer-events:none"
    }
  }, [_vm.showPanelName === "style" ? _c("div", {
    staticClass: "uc-style-thumnail-stand",
    class: {
      "uc-style-thumnail-topLayer": _vm.modifyField && _vm.modifyField.indexOf("padding") !== -1
    },
    style: _vm.paddingStandObj
  }, [_c("div", {
    staticClass: "uc-style-thumnail-anchor-tip-wrapper"
  }, _vm._l(_vm.uiData.fieldSet.padding.filter(function (item) {
    return _vm.modifyField === item.fieldName;
  }), function (group, index) {
    return _c("span", {
      key: index,
      class: "uc-style-thumnail-anchor-tip-" + group.direction
    }, [_vm._v("\n                " + _vm._s(_vm.deltaValue > 0 ? "+" + _vm.deltaValue : "" + _vm.deltaValue) + "\n              ")]);
  }), 0)]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "uc-style-thumnail-anchor-wrapper"
  }, _vm._l(_vm.uiData.fieldSet.padding, function (group, index) {
    return _c("div", {
      key: index,
      class: "uc-style-thumnail-anchor uc-style-thumnail-anchor-" + group.direction,
      on: {
        mousedown: function (e) {
          _vm.handleAnchorMove(e, group.fieldName);
        },
        touchstart: function (e) {
          _vm.handleAnchorMove(e, group.fieldName);
        }
      }
    });
  }), 0), _vm._v(" "), _c("span", {
    staticClass: "uc-style-thumnail-title"
  }, [_vm._v("\n          内边距\n        ")]), _vm._v(" "), _c("div", {
    staticClass: "uc-style-thumnail uc-style-thumnail-content",
    class: {
      "uc-style-thumnail-highlight": _vm.highlight === "content"
    },
    style: {
      borderRadius: _vm.style.borderRadius + "px"
    },
    on: {
      mouseenter: function () {
        _vm.handleMouseEnter("content");
      },
      mouseleave: function () {
        _vm.handleMouseLeave("content");
      }
    }
  }, [_c("span", {
    staticClass: "uc-style-thumnail-title"
  }, [_c("span", {
    staticClass: "uc-style-thumnail-content-unit",
    staticStyle: {
      position: "absolute",
      left: "0"
    },
    on: {
      dblclick: _vm.handleContentDbClick
    }
  }, [_vm._v("\n              " + _vm._s("" + (this.style.width || "auto")) + "\n            ")]), _vm._v(" "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.style.width,
      expression: "style.width",
      modifiers: {
        number: true
      }
    }],
    class: "uc-mini-inputbox",
    staticStyle: {
      position: "absolute",
      left: "0"
    },
    domProps: {
      value: _vm.style.width
    },
    on: {
      input: function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.style, "width", _vm._n($event.target.value));
      },
      blur: function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm._v(" "), _c("span", [_vm._v("\n              x\n            ")]), _vm._v(" "), _c("span", {
    staticClass: "uc-style-thumnail-content-unit",
    staticStyle: {
      position: "absolute",
      right: "0"
    },
    on: {
      dblclick: _vm.handleContentDbClick
    }
  }, [_vm._v("\n              " + _vm._s("" + (this.style.height || "auto")) + "\n            ")]), _vm._v(" "), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.style.height,
      expression: "style.height",
      modifiers: {
        number: true
      }
    }],
    class: "uc-mini-inputbox",
    staticStyle: {
      position: "absolute",
      right: "0"
    },
    domProps: {
      value: _vm.style.height
    },
    on: {
      input: function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.style, "height", _vm._n($event.target.value));
      },
      blur: function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])], 1)])], 1), _vm._v(" "), _c("input", {
    staticStyle: {
      width: "0",
      height: "0",
      padding: "0",
      margin: "0",
      border: "0"
    },
    attrs: {
      id: "blurInputAnchor"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/StylePanel/comps/LayoutBox/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);